// Mock-Daten für Portfolio-Website

export const portfolioData = {
  name: "WebWerk Kelsterbach",
  tagline: "Moderne Websites für lokale Unternehmen",
  description: "Ich erstelle professionelle Websites für kleine Unternehmen in Kelsterbach und Umgebung.",
  email: "kontakt@webwerk-kelsterbach.de",
  phone: "+49 (0) 6107 123456",
  location: "Kelsterbach, Deutschland",
  
  services: [
    {
      id: 1,
      title: "Website-Design & Entwicklung",
      description: "Maßgeschneiderte Websites, die auf Ihre Geschäftsanforderungen zugeschnitten sind - mit modernem Design und Funktionalität.",
      icon: "layout"
    },
    {
      id: 2,
      title: "Lokales SEO & Online-Präsenz",
      description: "Steigern Sie Ihre Sichtbarkeit in lokalen Suchergebnissen und gewinnen Sie mehr Kunden in Ihrer Region.",
      icon: "search"
    },
    {
      id: 3,
      title: "Mobile-Responsive Websites",
      description: "Websites, die auf allen Geräten und Bildschirmgrößen perfekt aussehen und nahtlos funktionieren.",
      icon: "smartphone"
    },
    {
      id: 4,
      title: "Website-Wartung & Support",
      description: "Fortlaufende Unterstützung, Updates und Wartung, damit Ihre Website reibungslos läuft.",
      icon: "settings"
    },
    {
      id: 5,
      title: "Website-Hosting & Sicherheit",
      description: "Zuverlässige Hosting-Lösungen mit SSL-Zertifikaten und regelmäßigen Sicherheitsupdates.",
      icon: "shield"
    }
  ],
  
  projects: [
    {
      id: 1,
      title: "Restaurant-Website",
      description: "Moderne responsive Website für ein lokales Restaurant mit Online-Menü und Reservierungssystem.",
      category: "Unternehmenswebsite",
      image: "https://images.unsplash.com/photo-1481487196290-c152efe083f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHx3ZWJzaXRlJTIwbW9ja3VwfGVufDB8fHx8MTc3MzU0Nzg5OXww&ixlib=rb-4.1.0&q=85",
      technologies: ["React", "Node.js", "MongoDB"]
    },
    {
      id: 3,
      title: "Kosmetikstudio-Website",
      description: "Elegante Website für ein Kosmetikstudio mit Terminbuchung und Leistungsübersicht.",
      category: "Unternehmenswebsite",
      image: "https://images.unsplash.com/photo-1611169035510-f9af52e6dbe2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxiZWF1dHklMjBzYWxvbiUyMHNwYXxlbnwwfHx8fDE3NzM1Nzk2Njh8MA&ixlib=rb-4.1.0&q=85",
      technologies: ["React", "CSS", "JavaScript"]
    },
    {
      id: 4,
      title: "Handwerker-Website",
      description: "Professionelle Website für einen Handwerksbetrieb mit Leistungsübersicht und Kontaktformular.",
      category: "Unternehmenswebsite",
      image: "https://images.unsplash.com/photo-1615974679600-665fb9468c4f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxoYW5keW1hbiUyMGNhcnBlbnRlcnxlbnwwfHx8fDE3NzM1Nzk2Nzh8MA&ixlib=rb-4.1.0&q=85",
      technologies: ["React", "Node.js", "MongoDB"]
    }
  ],
  
  about: {
    title: "Über mich",
    paragraphs: [
      "Ich helfe lokalen Unternehmen und Selbstständigen, online sichtbar zu werden. Mit Erfahrung in der Entwicklung maßgeschneiderter Web-Lösungen verstehe ich die besonderen Herausforderungen, vor denen kleine Unternehmen stehen.",
      "Mein Ansatz ist einfach: Ich höre auf Ihre Bedürfnisse, verstehe Ihre Ziele und liefere Lösungen, die für Ihr Unternehmen funktionieren. Ob Sie eine einfache Website oder eine E-Commerce-Plattform benötigen - ich bin hier, um Ihnen zu helfen.",
      "Ich glaube an den Aufbau langfristiger Beziehungen und biete nicht nur Websites, sondern auch fortlaufende Unterstützung, um Ihr Unternehmen wachsen zu lassen."
    ]
  }
};